// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import Action from './Action';
// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import Create from './Create';
// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import Delete from './Delete';
import Finder from './Finder';
import Get from './Get';
import GetAll from './GetAll';
import LocalGet from './LocalGet';
import LocalMultiGet from './LocalMultiGet';
import MultiGet from './MultiGet';
// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import Patch from './Patch';
// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import Update from './Update';

const exported = {
  Get,
  LocalGet,
  LocalMultiGet,
  MultiGet,
  GetAll,
  Finder,
  Action,
  Create,
  Update,
  Delete,
  Patch,
};

export default exported;
export { Get, LocalGet, LocalMultiGet, MultiGet, GetAll, Finder, Action, Create, Update, Delete, Patch };
